import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { Center, Image, VStack } from '@chakra-ui/react';

import flyingBills from 'assets/brand/flying-bills.png';
import { formatAmount } from 'common/formatAmount';
import Button from 'components/_core/Button';
import Card from 'components/_core/Card';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import { StepProps } from 'components/Stepper/types';

import * as routes from '../../../../../../routes';
import { useBankTransferRequestsNewState } from '../../../BankTransferRequestsNewProvider';
import locales from './locales';

const TransferSuccess: FC<StepProps> = () => {
  const { transferInformation } = useBankTransferRequestsNewState();

  if (transferInformation.amount === undefined) {
    throw new Error('Could not retrieve transfer amount');
  }

  return (
    <Center background="white" inset={0} position="absolute" zIndex="modal">
      <VStack
        alignItems="stretch"
        as={Card}
        paddingX="space-32"
        paddingY="space-24"
        spacing="space-32"
        textAlign="center"
        width="540px"
      >
        <Image marginX="auto" src={flyingBills} width="180px" />
        <Heading size="lg">{locales.title}</Heading>
        <Text variant="secondary">{locales.subtitle}</Text>
        <Text
          background="grey.200"
          borderRadius="radius-8"
          fontSize="font-31"
          fontWeight="weight-500"
          paddingX="space-24"
          paddingY="space-16"
          sx={{
            fontFeatureSettings: 'tnum',
            fontVariantNumeric: 'tabular-nums',
          }}
          variant="primary"
        >
          {formatAmount({
            forcePlusSign: false,
            value: transferInformation.amount,
          })}
        </Text>
        <Button alignSelf="center" as={Link} to={routes.root}>
          {locales.submit}
        </Button>
      </VStack>
    </Center>
  );
};

export default TransferSuccess;
